module.exports = __webpack_public_path__ + "973cf8b6489946965507763fe8849542.jpg";